import { z } from 'zod';
import { apiGet, apiPost, demoMode } from './api';
import { demoOwnerBookings, demoUpdateBookingStatus } from './demo';

// Записи салона для кабинета владельца.
// Демо: всё, что создано в этой сессии вкладки.
// Прод: сервер отдаёт записи только того салона, к которому привязана
// сессия владельца (cookie mnc_owner -> tenant_id).
export const OwnerBookingSchema = z.object({
  id: z.string(),
  service_id: z.string(),
  staff_id: z.string(),
  resource_id: z.string(),
  starts_at: z.string(),
  ends_at: z.string(),
  client_name: z.string(),
  client_phone: z.string(),
  service_name: z.string(),
  staff_name: z.string().nullable().optional(),
  price: z.number().nullable(),
  status: z.enum(['pending', 'confirmed', 'cancelled', 'done'])
});

export type OwnerBooking = z.infer<typeof OwnerBookingSchema>;

export async function fetchOwnerBookings(_tenantId: string): Promise<OwnerBooking[]> {
  if (demoMode) {
    return z.array(OwnerBookingSchema).parse(demoOwnerBookings());
  }

  const data = await apiGet<unknown>('/owner/bookings');
  return z.array(OwnerBookingSchema).parse(data);
}

// Отмена записи владельцем. Статус меняется на 'cancelled', запись остаётся в истории.
export async function cancelOwnerBooking(id: string): Promise<void> {
  return updateOwnerBookingStatus(id, 'cancelled');
}

export async function updateOwnerBookingStatus(
  id: string,
  status: OwnerBooking['status']
): Promise<void> {
  if (demoMode) return demoUpdateBookingStatus(id, status);
  await apiPost<{ ok: boolean }>('/owner/booking-action', { id, status });
}
